import FetchRequest from "@/api/FetchRequest";
class fileApi {
    // 基础url
    static url = "/ai/voice/file/";
    // 查询列表
    static getList(pageNum: number, pageSize: number,parentId:number): Promise<any> {
        return FetchRequest.get(this.url + 'list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize + '&parentId=' + parentId ,true );
    }
    static getListKey(pageNum: number, pageSize: number,parentId:number ,title:number): Promise<any> {
        return FetchRequest.get(this.url + 'list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&parentId=' + parentId  + '&title=' + title ,true );
    }
    // 更改目录
    static putFile(fileId:string,parentId: string): Promise<any> {
        const data={
            parentId:parentId,
        }
        return FetchRequest.put(this.url +'change/folder/'+ fileId+'?parentId='+parentId	,'' , true);
    }
    // 删除文件
    static delFile(fileIds: string): Promise<any> {
       
        return FetchRequest.del(this.url+'file/' +fileIds,'' , true);
    }
    // 新增文件夹
    static addFolder(filename:string,parentId:number): Promise<any> {
        const data={
            filename:filename,
            parentId:parentId,
        }
        return FetchRequest.post(this.url + 'folder'+'?parentId='+parentId+'&filename='+filename ,'' , true);
    }
    // 获取所有目录
    static getFolderList(): Promise<any> {
        return FetchRequest.get(this.url + 'folder/all' ,true );
    }
    // 删除文件夹
    static delFolder(fileId: string): Promise<any> {
       
        return FetchRequest.del(this.url+'folder/' +fileId,'' , true);
    }
    // 重命名
    static putRename(fileId:string,filename: string): Promise<any> {
        return FetchRequest.put(this.url +'rename/'+ fileId+'?filename='+filename	,'' , true);
    }
   

}
export default fileApi;